
export const ANONYMOUS = [
  { label: "실명", value: "0" },
  { label: "익명", value: "1" },
]

export const SECRET = [
  { label: "공개", value: "0" },
  { label: "비공개", value: "1" },
]
export const NOTICE = [
  { label: "일반글", value: "0" },
  { label: "공지사항", value: "1" },
]

export const COMMUNITY_BOARD_SEARCH_OPTIONS = [
  { label: "제목", value: "title" },
  { label: "내용", value: "content" },
]

export const COMMUNITY_TAX_MANAGER_LIST = [ 
  { label: "사용 금지", value: 0 },
  { label: "사용 허가", value: 1 }, 
]

export const COMMUNITY_ALARM_LIST = [ 
  { label: "알림 없음", value: 0 },
  { label: "새 게시글 알림", value: 1 },
  { label: "새 게시글/댓글 모두 알림", value: 2 }, 
]